import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2,
              @Inject(DOCUMENT) private document) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public lockBodyScroll() {
    const body: HTMLBodyElement = this.document.body as HTMLBodyElement;
    this.renderer.addClass(body, 'overflow-hidden');
  }

  public unlockBodyScroll() {
    const body: HTMLBodyElement = this.document.body as HTMLBodyElement;
    this.renderer.removeClass(body, 'overflow-hidden');
  }
}
